import { useQuery } from '@tanstack/react-query'
import { Checkbox, Flex, Radio } from 'antd'
import dayjs from 'dayjs'
import { useFormik } from 'formik'
import CustomDataTable from 'general/components/CustomDataTable'
import BaseTextField from 'general/components/Forms/BaseTextField'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import KTFormInput, {
  KTFormInputBTDPickerType,
  KTFormInputType,
} from 'general/components/Forms/KTFormInput'
import ButtonGroupTab from 'general/components/Tab'
import Global from 'general/utils/Global'
import Utils, { getYearsFromDates } from 'general/utils/Utils'
import ValidationSchema from 'general/utils/ValidationSchema'
import { useAppSelector } from 'hooks/useRedux'
import useSearchDebounce from 'hooks/useSearchDebounce'
import useToken from 'hooks/useToken'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useRef, useState } from 'react'
import DraggableModal from '../DragableModal/DraggableModal'
import { queryKeys } from './queries'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import SelectOptions from 'general/constants/SelectOptions'
import useFilter from 'hooks/useFilter'
import useGetSerials from 'hooks/Queries/useGetSerials'
import _, { repeat } from 'lodash'
import useRouter from 'hooks/useRouter'

FindInvoiceModalTradeDiscount.propTypes = {
  selectableRows: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onExistDone: PropTypes.func,
  title: PropTypes.string,
  showTab: PropTypes.bool,
  textButtonTab1: PropTypes.string,
  textButtonTab2: PropTypes.string,
  checkBoxShow: PropTypes.bool,
  buttonAgreeOnlick: PropTypes.func,
  buttonAgreeTab2Onlick: PropTypes.func,
  onRowClicked: PropTypes.func,
  buttonAgreeVisibility: PropTypes.bool,
  invoiceType: PropTypes.string,
  defaultTab: PropTypes.number,
}

FindInvoiceModalTradeDiscount.defaultProps = {
  selectableRows: false,
  show: false,
  onClose: null,
  showTab: true,
  onExistDone: null,
  textButtonTab1: `Hóa đơn`,
  textButtonTab2: 'Hóa đơn trên hệ thống khác',
  checkBoxShow: true,
  buttonAgreeVisibility: false,
  invoiceType: 'issued',
}

function FindInvoiceModalTradeDiscount(props) {
  const {
    show,
    onHide,
    title,
    showTab,
    textButtonTab1,
    textButtonTab2,
    buttonAgreeOnlick,
    onRowClicked,
    selectableRows,
    buttonAgreeVisibility,
    buttonAgreeTab2Onlick,
    invoiceType,
    defaultTab,
    isInvoice = true,
  } = props
  const { token } = useToken()
  const { debouncedSearch, setSearch } = useSearchDebounce('')
  const modalRef = useRef(null)
  const { pathname } = useRouter()
  const partsName = pathname.split('/')

  const [currentTab, setCurrentTab] = useState(0)
  const [filters, setFilters] = useState({
    ...Global.gFiltersInvoiceList_findmodal,
    classify: partsName.includes('may-tinh-tien') ? 'MTT' : 'HD',
  })
  const [selectedInvoices, setSelectedInvoices] = useState([])
  const [clearSelected, setClearSelected] = useState(false)
  const radioGroups = [
    { label: 'Hóa đơn', value: 'HD' },
    // { label: 'HĐ không có mã của CQT', value: 'PXK' },
    { label: 'Hóa đơn từ máy tính tiền', value: 'MTT' },
  ]
  const ticketRadioGroup = [
    { label: 'Vé theo NĐ254 (Có mã)', value: 'HD' },
    { label: 'Vé theo NĐ254 (Khởi tạo từ máy tính tiền)', value: 'MTT' },
  ]
  const sysConfig = useAppSelector((s) => s.systemConfig.formatNumber)
  const [filter, setFilter] = useFilter(
    'invoiceErrAnnouce',
    'gFilterInvoiceErrAnnouce',
  )
  const [dateSerial, setDateSerial] = useState([])
  const [viewInvoiceProduct, setViewInvoiceProduct] = useState(() => {
    return sessionStorage.getItem('viewInvoiceProduct') === 'true'
  })
  const { data: serials } = useGetSerials(
    filters.classify,
    undefined,
    dateSerial,
  )
  const filterCriteria = useMemo(
    () => [
      {
        label: 'Ký hiệu',
        alias: 'Ký hiệu',
        formName: 'serials',
        options: serials,
        value: _.isEmpty(serials) ? null : (serials[0]?.value ?? null),
        multiselect: true,
      },
      {
        label: 'Loại hoá đơn',
        alias: 'Loại HĐ',
        formName: 'types',
        options: SelectOptions.invoiceTypeToQueryErrAnnouce,
        value: null,
      },
      {
        label: ['Hoá đơn từ số', 'Đến số'],
        formName: ['fromNumberInvoice', 'toNumberInvoice'],
        alias: 'Số hoá đơn: Từ',
        separator: 'đến',
        value: [null, null],
        restrict: {
          type: 'number',
          min: 1,
          max: 99999999,
        },
      },
    ],
    [serials],
  )
  const formik = useFormik({
    initialValues: {
      no: '',
      serial: '',
      taxAuthorityCode: '',
      date: dayjs().utc().format('L'),
    },
    validationSchema: ValidationSchema.findInvoice,
    enableReinitialize: false,
    validateOnChange: false,
  })

  const { data: dataSource, isLoading: gettingListData } = useQuery({
    ...queryKeys.lists(
      {
        ...filter,
        ...filters,
        ...(currentTab === 2 ? { notViewInvoiceSendTaxStatus: 1 } : {}),
        refErrorInvoiceCode: 1,
      },
      invoiceType,
      isInvoice,
    ),
    enabled: currentTab === 0 && show,
  })

  // Effect

  useEffect(() => {
    if (defaultTab === 1) setCurrentTab(defaultTab)
  }, [defaultTab])

  useEffect(() => {
    if (show) {
      setClearSelected((prev) => !prev)
      setFilters((prev) => ({
        ...prev,
        ...Global.gFiltersInvoiceList_findmodal,
        q: debouncedSearch,
        classify: filters.classify,
        ...filter,
      }))
    }
  }, [debouncedSearch, show, filter, filters.classify])

  const allColumns = [
    {
      name: 'Ký hiệu',
      width: '110px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.serial}
          </p>
        )
      },
    },
    {
      name: 'Số',
      width: '110px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {Utils.padString(row?.no, 8, '0')}
          </p>
        )
      },
    },
    {
      name: 'Ngày HĐ',
      width: '125px',
      cell: (row) => {
        const date = dayjs(isInvoice ? row?.date : row?.dateRelease)
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {date.isValid() ? date.format('L') : ''}
          </p>
        )
      },
    },
    {
      name: 'Khách hàng',
      // width: '300px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.customerCompanyName}
          </p>
        )
      },
      hidden: filters.classify === 'PXK',
    },
    {
      name: 'Đại lý/Đơn vị nhận hàng',
      // width: '300px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.consigneeUnitName || row?.invoiceNote}
          </p>
        )
      },
      hidden: filters.classify !== 'PXK',
    },
    {
      name: 'Tổng tiền',
      // sortable: false,
      // right: true,
      width: '200px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {Utils.valueFormatted(
              isInvoice ? row?.totalAfterTax : row?.totalPrice,
              row?.numberFormat,
              sysConfig,
              'totalCost',
            )}{' '}
            {row?.currency}
          </p>
        )
      },
    },
  ]

  const columns = allColumns.filter((column) => !column.hidden)

  const handleApplyChanges = () => {
    switch (currentTab) {
      case 0:
        buttonAgreeOnlick(selectedInvoices, filters.classify)
        break
      case 1:
        buttonAgreeTab2Onlick(formik.values)
        break
      default:
        return
    }
  }

  const handleDoubleClickInvoice = (row) => {
    onRowClicked(row, filters.classify, viewInvoiceProduct)
  }

  const onchangeDate = (name, value, dateRange) => {
    if (name) {
      setDateSerial(getYearsFromDates({ ...filters, [name]: value }))
    } else {
      setDateSerial(
        getYearsFromDates({
          ...filters,
          startDate: dateRange[0],
          endDate: dateRange[1],
        }),
      )
    }
  }

  useEffect(() => {
    setDateSerial(getYearsFromDates(filters))
  }, [])

  const onChange = (e) => {
    const checked = e.target.checked
    setViewInvoiceProduct(checked)
    sessionStorage.setItem('viewInvoiceProduct', checked)
  }

  return (
    <DraggableModal
      applyText="Đồng ý"
      ref={modalRef}
      handleApplyChanges={handleApplyChanges}
      title={title}
      hasApplyButton={buttonAgreeVisibility}
      isOpen={show}
      onOpenChange={() => onHide()}
      width={'80%'}
      styles={{
        header: {
          borderBottom: Utils.cn('1px solid', token.colorBorderSecondary),
          margin: 0,
        },
        body: {
          padding: 0,
        },
        footer: {
          borderTop: Utils.cn('1px solid', token.colorBorderSecondary),
        },
      }}
    >
      <div style={{ marginTop: 15, marginLeft: 12 }}>
        <span>
          <b>Lưu ý</b>: Việc chọn hóa đơn là <b>không bắt buộc</b>, bạn chỉ nên
          chọn nếu muốn quản lý các hóa đơn này trên phần mềm.
        </span>
        <br></br>
        <span>
          Số lượng tối đa:
          <b> 2.000</b> hóa đơn.
        </span>
      </div>
      <div className="d-flex justify-content-center align-items-center w-100 my-4"></div>

      <div className="p-0">
        {currentTab === 0 ? (
          <>
            <div
              className="d-flex flex-column"
              style={{
                backgroundColor: '#f3f5f7',
                fontSize: '14px',
              }}
            >
              <Flex justify="flex-start" className="p-3 fw-light">
                <Radio.Group
                  options={isInvoice ? radioGroups : ticketRadioGroup}
                  onChange={(e) => {
                    setFilters((prev) => ({
                      ...prev,
                      classify: e.target.value,
                    }))
                  }}
                  value={filters.classify}
                />
              </Flex>
              <Flex gap={'5px'} className="p-3 w-100">
                {/* <CustomAntRangePicker
                  dateFormat="L"
                  defaultValue={[
                    dayjs(filters.startDate),
                    dayjs(filters.endDate),
                  ]}
                  defaultPeriod={filters.period}
                  onChange={(range, period) => {
                    setFilters({
                      ...filters,
                      startDate: dayjs(range[0]).format(),
                      endDate: dayjs(range[1]).format(),
                      period,
                    })
                  }}
                  position="bottomLeft"
                  borderRadius="sm"
                /> */}

                <div style={{ width: '250px' }}>
                  <CustomAntInput
                    type="search"
                    borderRadius="sm"
                    inputProps={{
                      defaultValue: debouncedSearch,
                      onChange: (e) => setSearch(e.target.value),
                    }}
                    // width={'25%'}
                  />
                </div>
                <div
                  style={{
                    width: '100%',
                    maxWidth: '750px',
                    display: 'flex',
                  }}
                >
                  <FilterPopover
                    defaultValues={filterCriteria}
                    onApply={setFilter}
                    savedKey={'gFilterInvoiceErrAnnouce'}
                    onchangeDate={onchangeDate}
                  />
                </div>
              </Flex>
            </div>

            <div className="m-3">
              <CustomDataTable
                wrapperClassName="max-h-300px"
                columns={columns}
                dataSource={dataSource?.rows}
                isLoading={gettingListData}
                scrollY="300px"
                isSelectable={selectableRows}
                pagination={{
                  currentPage: filters?.page,
                  rowsPerPage: filters?.limit,
                  total: dataSource?.total,
                  onChangePage: (page) => {
                    setFilters({
                      ...filters,
                      page,
                    })
                  },
                  onChangeRowsPerPage: (limit) => {
                    setFilters({
                      ...filters,
                      limit,
                      page: 1,
                    })
                  },
                }}
                selectedRows={{
                  clearSelectedRows: clearSelected,
                  handleSelectedRows: ({ selectedRows }) => {
                    setSelectedInvoices(selectedRows)
                  },
                  selectableRowSelected: (row) =>
                    selectableRows?.some(
                      (item) => item.invoiceId === row.invoiceId,
                    ),
                  // selectableRowSelected: (row) =>
                  //   selectedInvoices?.some((item) => {
                  //     if (isInvoice) return item.invoiceId === row.invoiceId
                  //     else return item.ticketId === row.ticketId
                  //   }),
                }}
                isClickable
                handleDoubleClickRow={handleDoubleClickInvoice}
              />
            </div>
          </>
        ) : (
          <>
            <div
              className="d-flex flex-column w-50"
              style={{
                fontSize: '14px',
                fontWeight: '500',
                color: '#333333',
                gap: '8px',
                padding: '15px',
                marginBottom: '20px',
                marginTop: '10px',
              }}
            >
              <div className="d-flex flex-column" style={{ gap: '5px' }}>
                <span>Mã cơ quan thuế (Với hóa đơn có mã)</span>
                <div>
                  <BaseTextField
                    className="flex-grow-1"
                    fieldProps={formik.getFieldProps('taxAuthorityCode')}
                    fieldMeta={formik.getFieldMeta('taxAuthorityCode')}
                    fieldHelper={formik.getFieldHelpers('taxAuthorityCode')}
                  />
                </div>
              </div>
              <div className="d-flex flex-column" style={{ gap: '5px' }}>
                <span>
                  Ký hiệu <span style={{ color: 'red' }}>(*)</span>
                </span>
                <div>
                  <BaseTextField
                    className="flex-grow-1"
                    fieldProps={formik.getFieldProps('serial')}
                    fieldMeta={formik.getFieldMeta('serial')}
                    fieldHelper={formik.getFieldHelpers('serial')}
                  />
                </div>
              </div>
              <div className="d-flex flex-column" style={{ gap: '5px' }}>
                <span>
                  Số hóa đơn <span style={{ color: 'red' }}>(*)</span>
                </span>
                <BaseTextField
                  className="flex-grow-1"
                  fieldProps={formik.getFieldProps('no')}
                  fieldMeta={formik.getFieldMeta('no')}
                  fieldHelper={formik.getFieldHelpers('no')}
                />
              </div>
              <div className="d-flex flex-column" style={{ gap: '5px' }}>
                <span>
                  Ngày hóa đơn <span style={{ color: 'red' }}>(*)</span>
                </span>
                <KTFormInput
                  name="1"
                  value={formik.getFieldProps('date').value}
                  onChange={(value) => {
                    formik.setFieldValue('date', value)
                  }}
                  onFocus={() => {
                    formik.setFieldTouched('date', true)
                  }}
                  enableCheckValid
                  btdPickerType={KTFormInputBTDPickerType.date}
                  // isValid={_.isEmpty(meta.error)}
                  // isTouched={meta.touched}
                  // feedbackText={meta.error}
                  type={KTFormInputType.date}
                  // disabled={!canEdit}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </DraggableModal>
  )
}

export default FindInvoiceModalTradeDiscount
